import script from "./RecreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./RecreateForm.vue?vue&type=style&index=0&id=46ad84ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ad84ba"]])

export default __exports__